import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { combineLocationString, splitLocationString } from '@mdd/api';

export function createRouterLocation(route: ActivatedRouteSnapshot, router: Router): Location {
    // TODO: Update @mdd/api typings to be less strict for this
    const searchStr = combineLocationString(route.queryParams);
    return <any>{
        get hash() {
            return route.fragment!;
        },

        set hash(hash: string) {
            router.navigate([], { fragment: hash, replaceUrl: true });
        },

        get search() {
            return searchStr;
        },

        set search(search: string) {
            router.navigate([], {
                queryParams: splitLocationString(search),
                replaceUrl: true
            });
        }
    };
}
